import CreateMatch2 from './CreateMatch2';

export default CreateMatch2;